import { render, staticRenderFns } from "./PreMatriculaFormPage.vue?vue&type=template&id=3ee7271e&scoped=true"
import script from "./PreMatriculaFormPage.vue?vue&type=script&lang=js"
export * from "./PreMatriculaFormPage.vue?vue&type=script&lang=js"
import style0 from "./PreMatriculaFormPage.vue?vue&type=style&index=0&id=3ee7271e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee7271e",
  null
  
)

export default component.exports